module.exports = __webpack_public_path__ + "static/media/TD.39221140.svg";